@if (form) {
  <div>
    <rt-requisitions-toolbar
      [requisition]="requisition"
      [isFormPristine]="form.pristine"
      [canCreateJob]="canCreateJob"
      [requestApprovalDisabled]="requestApprovalDisabled"
      [hasManageActions]="hasManageActions"
      [hasManageActionsDisabled]="isEditingOpenings"
      [hideManageActionsUnderMore]="
        isCurrentUserApproverInAnyStep && requisition.status === RequisitionStatus.Pending
      "
      [hasApproverActions]="isCurrentUserApproverInActiveStep"
      [hasSave]="isFormEditable"
      (duplicate)="duplicate()"
      (save)="save()"
      (requestApproval)="requestApproval()"
      (cancelRequest)="cancelRequest()"
      (approveRequest)="approveRequest()"
      (rejectRequest)="rejectRequest()"
      (createJob)="createJob()"
      (archive)="archive()"
      (retrieve)="retrieve()"
      (delete)="delete()"
    ></rt-requisitions-toolbar>

    @if (showFeatureDiscoveryVideoInfobox) {
      <rt-infobox-video
        [heading]="'app.onboarding.feature_videos.requisitions.heading' | translate"
        [content]="'app.onboarding.feature_videos.requisitions.content' | translate"
        [video]="OnboardingVideoId.Requisitions"
        [featureDiscoveryKey]="featureDiscoveryKey"
        [storageKey]="'requisitions-feature-discovery-video-infobox'"
        analyticsFeatureName="Requisitions"
        margin-bottom
      ></rt-infobox-video>
    }

    @if (showApprovalRequestMessage) {
      <rt-approval-request-message-box
        [requester]="adminsMap[requisition.approvalRequest!.requesterId] || null"
        [attachments]="requisition.approvalRequest!.attachments"
        [bodyHtml]="requisition.approvalRequest!.bodyHtml"
        [createdAt]="requisition.approvalRequest!.createdAt"
      ></rt-approval-request-message-box>
    }

    @if (requisition.status === RequisitionStatus.Pending && hasManageActions) {
      <rt-infobox
        [heading]="'app.requisitions.details_page.pending_approval_infobox.heading' | translate"
        iconName="info-outline"
        [isDismissible]="true"
        [storageKey]="'requisition-pending-approval-infobox'"
        type="transparent"
        margin-bottom
      >
        {{ 'app.requisitions.details_page.pending_approval_infobox.description' | translate }}
      </rt-infobox>
    }

    @if (!!requisition?.rejectionReason && requisition?.status === RequisitionStatus.Rejected) {
      <rt-requisitions-rejection-infobox margin-bottom></rt-requisitions-rejection-infobox>
    }

    <div class="form" [rtProtectedControl]="form">
      @if (isFormBoxVisible(FormBox.Context)) {
        <rt-requisitions-context-form
          [generalContextControl]="form.controls.generalContextJson!"
          [isFormEditable]="isFormEditable"
        ></rt-requisitions-context-form>
      }
      @if (isFormBoxVisible(FormBox.Details)) {
        <rt-requisitions-details-form
          [form]="form"
          [availableDetailsFields]="availableFieldsMap.details"
          [departmentSelectOptions]="departmentSelectOptions"
          [isFormEditable]="isFormEditable"
          [isDepartmentsMode]="isDepartmentsMode"
        ></rt-requisitions-details-form>
      }
      @if (isFormBoxVisible(FormBox.Location)) {
        <rt-requisitions-location-form
          [form]="form"
          [isFormEditable]="isFormEditable"
        ></rt-requisitions-location-form>
      }
      @if (isFormBoxVisible(FormBox.WorkModel)) {
        <rt-requisitions-work-model
          [form]="form"
          [isFormEditable]="isFormEditable"
        ></rt-requisitions-work-model>
      }
      <rt-requisitions-openings-form
        [openingsFormArray]="openingsFormArray"
        [availableOpeningsFields]="availableFieldsMap.openings"
        [isFormEditable]="isFormEditable"
        [canOnlyDecreaseOpenings]="requisition.status === RequisitionStatus.Approved"
        [canDeleteOpeningsAndUnassign]="canDeleteOpeningsAndUnassign"
        [deletedOpeningsCandidatesCount]="deletedOpeningsCandidatesCount"
        [savedOpenings]="savedOpenings"
        (forceOpeningsDelete)="forceOpeningsDelete()"
        (unassignCandidate)="unassignCandidate($event)"
        (isEditingOpening)="setIsEditingOpening($event)"
      ></rt-requisitions-openings-form>
    </div>
  </div>
}
